import script from "./Drawer.vue?vue&type=script&setup=true&lang=js"
export * from "./Drawer.vue?vue&type=script&setup=true&lang=js"

import "./Drawer.vue?vue&type=style&index=0&id=7518e2da&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7518e2da"]])

export default __exports__